import AdminRoleByScope from "./AdminRoleByScope";

import type { GetUserProfileResponse } from "../api/AdminUserAPI.types";

class UserProfile {
  uuid: string;

  lastName: string;

  firstName: string;

  email: string;

  avatar: string;

  roles: string[];

  constructor(user: GetUserProfileResponse) {
    this.uuid = user.uuid;
    this.lastName = user.last_name;
    this.firstName = user.first_name;
    this.email = user.email;
    this.avatar = user.avatar_url;
    this.roles = AdminRoleByScope.convertRolesFromBackend(user.roles);
  }

  get isOwnerOrAdmin(): boolean {
    return (
      this.roles?.some((role) => AdminRoleByScope.adminRoles.includes(role)) ||
      false
    );
  }
}

export default UserProfile;
